import styled from 'styled-components';

export const FieldMapperStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FieldMapperMessageBoxStyled = styled.div`
  margin: 20px 0;
  max-width: 750px;
`;

export const FieldNameStyled = styled.b`
  white-space: nowrap;
`;
